function pad(n) { return n < 10 ? '0' + n : '' + n; }

/* ---- Language switcher (DE default / EN optional) ----
   Any element with a data-en attribute holds its English text.
   On EN: we store the German original in data-de (once) and show English.
   On DE: we restore data-de. ---- */
function setLang(lang) {
  try { localStorage.setItem('nfl_lang', lang); } catch (e) {}
  applyLang(lang);
}

function applyLang(lang) {
  var nodes = document.querySelectorAll('[data-en]');
  for (var i = 0; i < nodes.length; i++) {
    var el = nodes[i];
    // Capture the German original the first time
    if (el.getAttribute('data-de') === null) {
      el.setAttribute('data-de', el.innerHTML);
    }
    var en = el.getAttribute('data-en');
    var de = el.getAttribute('data-de');
    if (lang === 'en' && en && en.length) {
      el.innerHTML = en;
    } else {
      el.innerHTML = de;
    }
  }
  // Toggle button active state
  var btns = document.querySelectorAll('.lang-btn');
  for (var j = 0; j < btns.length; j++) {
    btns[j].classList.toggle('active', btns[j].getAttribute('data-lang') === lang);
  }
  document.documentElement.setAttribute('lang', lang);
}

function initLang() {
  var saved = 'de';
  try { saved = localStorage.getItem('nfl_lang') || 'de'; } catch (e) {}
  applyLang(saved);
}

/* ---- Countdown (match day) ---- */
function startCountdown(iso) {
  var target = new Date(iso);
  function tick() {
    var diff = target - new Date();
    if (diff <= 0) return;
    var d = document.getElementById('cd-days');
    var h = document.getElementById('cd-hours');
    var m = document.getElementById('cd-mins');
    var s = document.getElementById('cd-secs');
    if (d) d.textContent = pad(Math.floor(diff / 86400000));
    if (h) h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    if (m) m.textContent = pad(Math.floor((diff % 3600000) / 60000));
    if (s) s.textContent = pad(Math.floor((diff % 60000) / 1000));
  }
  tick();
  setInterval(tick, 1000);
}

/* ---- FAQ accordion ---- */
function toggleFaq(btn) {
  var item = btn.closest('.faq-item');
  var open = item.classList.contains('open');
  var all = document.querySelectorAll('.faq-item.open');
  for (var i = 0; i < all.length; i++) { all[i].classList.remove('open'); }
  if (!open) item.classList.add('open');
}

/* ---- Ticket accordion ---- */
function toggleRow(id) {
  var row = document.getElementById(id);
  if (row) row.classList.toggle('open');
}

/* ---- Quantity selector ---- */
/* ---- Multi-category selection (accumulates across categories) ---- */
var ticketSelection = {}; // { c1: {qty, vid, eur, name}, ... }

function selectCatQty(cat, qty) {
  var grid = document.getElementById('qty-' + cat);
  if (!grid) return;

  // Toggle off if the same qty is clicked again
  var current = ticketSelection[cat] ? ticketSelection[cat].qty : 0;
  var newQty = (current === qty) ? 0 : qty;

  // Highlight buttons
  var btns = grid.querySelectorAll('.qty-btn');
  for (var i = 0; i < btns.length; i++) {
    if (btns[i].classList.contains('qty-disabled')) continue;
    var v = parseInt(btns[i].getAttribute('data-qty'), 10);
    if (v <= newQty && newQty > 0) {
      btns[i].classList.add('qty-selected');
    } else {
      btns[i].classList.remove('qty-selected');
    }
  }

  if (newQty > 0) {
    ticketSelection[cat] = {
      qty: newQty,
      vid: grid.getAttribute('data-vid'),
      eur: parseFloat(grid.getAttribute('data-eur')) || 0,
      name: grid.getAttribute('data-name')
    };
  } else {
    delete ticketSelection[cat];
  }
  renderOrderBar();
}

function renderOrderBar() {
  var linesEl = document.getElementById('orderBarLines');
  var totalEl = document.getElementById('orderBarTotal');
  var btn = document.getElementById('addAllBtn');
  if (!linesEl) return;

  var keys = Object.keys(ticketSelection);
  var total = 0;
  if (keys.length === 0) {
    var emptyTxt = currentLang() === 'en' ? 'Select your tickets in the categories above.' : 'Wähle deine Tickets in den Kategorien oben aus.';
    linesEl.innerHTML = '<div class="order-bar-empty">' + emptyTxt + '</div>';
    if (btn) btn.disabled = true;
  } else {
    var html = '';
    for (var i = 0; i < keys.length; i++) {
      var s = ticketSelection[keys[i]];
      var line = s.qty * s.eur;
      total += line;
      html += '<div class="order-bar-line">' +
        '<span class="order-bar-line-name">' + s.qty + '× ' + s.name + '</span>' +
        '<span class="order-bar-line-price">' + line.toFixed(2).replace('.', ',') + ' €</span>' +
        '</div>';
    }
    linesEl.innerHTML = html;
    if (btn) btn.disabled = false;
  }
  if (totalEl) totalEl.textContent = total.toFixed(2).replace('.', ',') + ' €';
}

/* ---- Meta Pixel helper (safe no-op if pixel not loaded) ---- */
function fbTrack(event, data) {
  if (typeof window.fbq === 'function') {
    try { window.fbq('track', event, data || {}); } catch (e) {}
  }
}

function addAllToCart() {
  var keys = Object.keys(ticketSelection);
  if (keys.length === 0) return;

  var items = [];
  var contents = [];
  var totalValue = 0;
  var totalQty = 0;
  for (var i = 0; i < keys.length; i++) {
    var s = ticketSelection[keys[i]];
    totalValue += s.qty * s.eur;
    totalQty += s.qty;
    if (s.vid && s.vid !== '') {
      items.push({ id: s.vid, quantity: s.qty });
      contents.push({ id: String(s.vid), quantity: s.qty });
    }
  }

  // Fire Meta Pixel AddToCart (works in preview & live)
  fbTrack('AddToCart', {
    content_type: 'product',
    contents: contents,
    currency: 'EUR',
    value: Math.round(totalValue * 100) / 100,
    num_items: totalQty
  });

  if (items.length === 0) {
    // No products linked yet (preview mode) — just open the drawer
    openCart();
    return;
  }

  var btn = document.getElementById('addAllBtn');
  var original = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.innerHTML = 'Wird hinzugefügt…'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      refreshCart(function () { openCart(); });
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
    });
}

/* ---- Track InitiateCheckout when the drawer checkout button is clicked ----
   Non-interfering: we do NOT preventDefault or alter the click, so the external
   checkout app can intercept the real (trusted) click/submit on its own. */
document.addEventListener('click', function (e) {
  if (!e.target.closest('.cart-checkout-btn')) return;
  try { fbTrack('InitiateCheckout', { currency: 'EUR' }); } catch (err) {}
});

/* ---- Legal modals ---- */
function openLegal(key) {
  var modal = document.getElementById('legal-' + key);
  var ov = document.getElementById('legalOverlay');
  if (!modal) return;
  var all = document.querySelectorAll('.legal-modal.open');
  for (var i = 0; i < all.length; i++) { all[i].classList.remove('open'); }
  modal.classList.add('open');
  if (ov) ov.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeLegal() {
  var ov = document.getElementById('legalOverlay');
  var all = document.querySelectorAll('.legal-modal.open');
  for (var i = 0; i < all.length; i++) { all[i].classList.remove('open'); }
  if (ov) ov.classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') { closeLegal(); }
});

/* ---- Cart drawer ---- */
function formatMoney(cents) {
  var v = (cents / 100).toFixed(2);
  var parts = v.split('.');
  var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return intPart + ',' + parts[1] + ' €';
}

function openCart() {
  var d = document.getElementById('cartDrawer');
  var o = document.getElementById('cartOverlay');
  if (d) d.classList.add('open');
  if (o) o.classList.add('open');
  document.body.style.overflow = 'hidden';
  startReservationTimer();
}

function closeCart() {
  var d = document.getElementById('cartDrawer');
  var o = document.getElementById('cartOverlay');
  if (d) d.classList.remove('open');
  if (o) o.classList.remove('open');
  document.body.style.overflow = '';
}

function updateCartCount(n) {
  var els = document.querySelectorAll('[data-cart-count]');
  for (var i = 0; i < els.length; i++) { els[i].textContent = n; }
}

function currentLang() {
  try { return localStorage.getItem('nfl_lang') || 'de'; } catch (e) { return 'de'; }
}

function renderCart(cart) {
  var en = currentLang() === 'en';
  var tQty = en ? 'Qty: ' : 'Anzahl: ';
  var tRemove = en ? 'Remove' : 'Entfernen';
  var tEmpty = en ? 'Your cart is empty.' : 'Dein Warenkorb ist leer.';
  var wrap = document.getElementById('cartItems');
  if (wrap) {
    if (cart.item_count === 0) {
      wrap.innerHTML = '<div class="cart-empty">' + tEmpty + '</div>';
    } else {
      var html = '';
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var img = it.image ? ('<img class="cart-line-img" src="' + it.image + '" alt="">') : '<div class="cart-line-img"></div>';
        html += '<div class="cart-line" data-key="' + it.key + '">' + img +
          '<div class="cart-line-info">' +
          '<div class="cart-line-title">' + it.product_title + '</div>' +
          '<div class="cart-line-variant">' + (it.variant_title ? it.variant_title : '') + '</div>' +
          '<div class="cart-line-meta">' +
          '<span class="cart-line-qty">' + tQty + it.quantity + '</span>' +
          '<span class="cart-line-price">' + formatMoney(it.final_line_price) + '</span>' +
          '</div>' +
          '<button class="cart-line-remove" onclick="removeItem(\'' + it.key + '\')">' + tRemove + '</button>' +
          '</div></div>';
      }
      wrap.innerHTML = html;
    }
  }
  var sub = document.getElementById('cartSubtotal');
  if (sub) sub.textContent = formatMoney(cart.total_price);
  updateCartCount(cart.item_count);
}

function refreshCart(cb) {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCart(cart);
      if (typeof cb === 'function') cb(cart);
    });
}

function removeItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCart(cart); });
}

/* ---- Reservation timer ---- */
function startReservationTimer() {
  var el = document.getElementById('cartTimerVal');
  var box = document.getElementById('cartTimer');
  if (!el || !box) return;
  var mins = parseInt(box.getAttribute('data-minutes'), 10);
  if (isNaN(mins) || mins <= 0) mins = 9;
  var key = 'nfl_res_expiry';
  var expiry = parseInt(sessionStorage.getItem(key), 10);
  if (!expiry || isNaN(expiry) || expiry - Date.now() <= 0) {
    expiry = Date.now() + mins * 60 * 1000;
    sessionStorage.setItem(key, String(expiry));
  }
  if (window._resTimer) clearInterval(window._resTimer);
  function upd() {
    var diff = expiry - Date.now();
    if (diff <= 0) {
      el.textContent = '00:00';
      box.classList.add('expired');
      clearInterval(window._resTimer);
      return;
    }
    var m = Math.floor(diff / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    el.textContent = pad(m) + ':' + pad(s);
  }
  upd();
  window._resTimer = setInterval(upd, 1000);
}

/* ---- Intercept Add-to-Cart ---- */
document.addEventListener('submit', function (e) {
  var form = e.target.closest('form[action="/cart/add"]');
  if (!form) return;
  e.preventDefault();
  var btn = form.querySelector('.cart-add-btn');
  var original = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.innerHTML = 'Wird hinzugefügt…'; }
  var data = new FormData(form);
  fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
    .then(function (r) { return r.json(); })
    .then(function () {
      refreshCart(function () { openCart(); });
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
      form.submit();
    });
});

document.addEventListener('DOMContentLoaded', function () {
  var c = document.querySelector('[data-countdown]');
  if (c) startCountdown(c.getAttribute('data-countdown'));
  initLang();
});
